import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import Loader from 'components/Loader'
import UserPicker from 'components/UserPicker'

export class SPUserPicker extends React.Component {
  static propTypes = {
    users: PropTypes.array.isRequired,
    usersByProfileKey: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    loaded: PropTypes.bool.isRequired,
    fetchSPUsers: PropTypes.func.isRequired,
    keyword: PropTypes.string,
    filter: PropTypes.func
  }

  constructor (props) {
    super(props)

    this.setUserPickerRef = this.setUserPickerRef.bind(this)
    this.getSelectedUsers = this.getSelectedUsers.bind(this)
    this.fetchUsers = this.fetchUsers.bind(this)
  }

  componentDidMount () {
    this.fetchUsers()
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.props.keyword !== prevProps.keyword) {
      this.fetchUsers()
    }
  }

  setUserPickerRef (ref) {
    this.userPickerRef = ref
  }

  getSelectedUsers () {
    return this.userPickerRef.getSelectedUsers().map(profileKey => this.props.usersByProfileKey[profileKey])
  }

  fetchUsers () {
    const { keyword, fetchSPUsers } = this.props

    fetchSPUsers({
      keyword
    })
  }

  render () {
    const {
      users,
      usersByProfileKey,
      loading,
      loaded,
      fetchSPUsers, // eslint-disable-line no-unused-vars
      keyword, // eslint-disable-line no-unused-vars
      filter,
      ...props
    } = this.props

    let filteredUsers = users.map(profileKey => usersByProfileKey[profileKey])
    if (filter) {
      filteredUsers = filteredUsers.filter(user => filter(user))
    }

    return (
      <div>
        {loading &&
          <Loader center />
        }
        {loaded &&
          <UserPicker
            {...props}
            ref={this.setUserPickerRef}
            users={filteredUsers}
            filter
          />
        }
        {(loaded && keyword && filteredUsers.length === 0) &&
          <span style={{ margin: '0 10px' }}>
            <FormattedMessage id='NOTHING_TO_SHOW' />
          </span>
        }
      </div>
    )
  }
}

export default SPUserPicker
